import React from "react"
import {useTranslation} from "react-i18next"
import {UserGroupIcon} from "@heroicons/react/24/outline"

export const NoProspectsWithoutAgent: React.FC = () => {
  const {t} = useTranslation()

  return (
    <div className={"my-14 flex flex-col items-center gap-8"}>
      <UserGroupIcon className={"h-28 w-28"} style={{strokeWidth: 0.5}} />
      <div className={"flex flex-col items-center gap-4"}>
        <h1 className={"text-2xl font-semibold"}>{t("Prospects_NoProspectsWithoutAgent_Title")}</h1>
      </div>
    </div>
  )
}
